import {reqUserInfo} from '../api/index.js'
import { LOGIN_IN_URL } from '../store/mutation-types.js'
export async function intercept (value) {
  let userinfo = await reqUserInfo()
  if (userinfo.users.length !== 0) {
    return true
  } else {
    if (value === 0) {
      window.location.href = LOGIN_IN_URL + window.encodeURIComponent(window.location.href)
    } else {
      return false
    }
  }
}
//兼容ios手机微信qq打开阅读不了跟下载不了问题，修改为原窗口打开
export function isAppleWechatOrQQ(url) {
  var ua = window.navigator.userAgent.toLowerCase();
  var isiOS = /iphone|ipad|ipod/.test(ua); // 更简洁的检测iOS设备的方式
  var isWechat = /micromessenger/.test(ua); // 微信
  var isQQ = /qq/.test(ua); // QQ
  if (isiOS && (isWechat || isQQ)) {
    window.location.href = url;
  } else {
    window.open(url);
  }
}


// WEBPACK FOOTER //
// ./src/util/loginAuthentication.js